// 协议签署事件：后端关键操作返回 403 TERMS_NOT_ACCEPTED 时，由 api 响应拦截器调用 notifyIfTermsRequired
// 广播，根组件 TermsModal 监听后弹出协议。单独成模块（不放 api.js）便于单测——api.js 依赖 axios ESM，jest 下不可直接加载。
export const TERMS_REQUIRED_EVENT = 'idelivery:terms-required';

export function notifyIfTermsRequired(error) {
  const res = error && error.response;
  if (res && res.status === 403 && res.data && res.data.code === 'TERMS_NOT_ACCEPTED') {
    window.dispatchEvent(new CustomEvent(TERMS_REQUIRED_EVENT, { detail: res.data }));
    return true;
  }
  return false;
}
